$(document).on('click', '.js-filter-show-hide', function () {
    $(this).find('.js-filter-show-hide-arrow').toggleClass('rotate-180');
    const el = $('.js-filter-show-hide-text');
    el.text(el.text() === "Show filter" ? "Hide filter" : "Show filter");
    $('.js-filter-form').fadeToggle();
});